/* Bay of Hayley — cookiemelding
 * Keuze wordt opgeslagen in localStorage ('boh_cookie') en doorgegeven aan de
 * Shopify Customer Privacy API, zodat Shopify-pixels (en apps die zich daaraan houden)
 * pas laden na toestemming. Opnieuw openen kan met: window.bohCookie.open()
 */
(function () {
  'use strict';
  var KEY = 'boh_cookie';
  var MAX_AGE = 365 * 24 * 60 * 60 * 1000; // na 12 maanden opnieuw vragen

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || typeof c !== 'object') return null;
      if (!c.ts || Date.now() - c.ts > MAX_AGE) return null;
      return c;
    } catch (e) { return null; }
  }

  function write(c) {
    try { window.localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
    try {
      // Fallback-cookie voor browsers zonder localStorage
      document.cookie = KEY + '=' + encodeURIComponent(JSON.stringify(c)) + '; max-age=' + Math.floor(MAX_AGE / 1000) + '; path=/; SameSite=Lax; Secure';
    } catch (e) {}
  }

  function applyToShopify(c, done) {
    var consent = {
      analytics: !!c.analytics,
      marketing: !!c.marketing,
      preferences: !!c.analytics,
      sale_of_data: !!c.marketing
    };
    function set() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () { if (done) done(); });
      } catch (e) { if (done) done(); }
    }
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      set();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err || !window.Shopify.customerPrivacy) { if (done) done(); return; }
        set();
      });
    } else if (done) { done(); }
  }

  function init() {
    var el = document.getElementById('bohCookie');
    if (!el) return;

    var ghost = el.querySelector('[data-act="decline"]');
    var analyticsSwitch = el.querySelector('[data-key="analytics"]');
    var marketingSwitch = el.querySelector('[data-key="marketing"]');
    var labels = {
      decline: ghost.getAttribute('data-label-decline') || ghost.textContent,
      save: ghost.getAttribute('data-label-save') || 'Opslaan'
    };

    function setOpen(open) {
      el.classList.toggle('is-open', open);
      ghost.textContent = open ? labels.save : labels.decline;
      ghost.dataset.act = open ? 'save' : 'decline';
    }

    function show(existing) {
      if (existing) {
        analyticsSwitch.setAttribute('aria-checked', existing.analytics ? 'true' : 'false');
        marketingSwitch.setAttribute('aria-checked', existing.marketing ? 'true' : 'false');
      }
      setOpen(false);
      el.hidden = false;
    }

    function save(c) {
      c.ts = Date.now();
      c.v = 1;
      write(c);
      el.hidden = true;
      applyToShopify(c);
      try {
        document.dispatchEvent(new CustomEvent('boh:cookie-consent', { detail: c }));
      } catch (e) {}
    }

    el.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !el.contains(t)) return;
      if (t.dataset.key) {
        if (t.disabled) return;
        t.setAttribute('aria-checked', t.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
        return;
      }
      var act = t.dataset.act;
      if (act === 'toggle') { setOpen(!el.classList.contains('is-open')); return; }
      if (act === 'decline') save({ analytics: false, marketing: false });
      if (act === 'accept') save({ analytics: true, marketing: true });
      if (act === 'save') save({
        analytics: analyticsSwitch.getAttribute('aria-checked') === 'true',
        marketing: marketingSwitch.getAttribute('aria-checked') === 'true'
      });
    });

    var stored = read();
    if (stored) {
      // Keuze is al gemaakt: alleen opnieuw doorgeven aan Shopify, melding blijft dicht.
      applyToShopify(stored);
    } else {
      show(null);
    }

    window.bohCookie = {
      open: function () { show(read() || null); },
      get: read
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
